import { render, staticRenderFns } from "./CompanyRepxStagesSettings.vue?vue&type=template&id=7ab2a9fc"
import script from "./CompanyRepxStagesSettings.vue?vue&type=script&lang=js"
export * from "./CompanyRepxStagesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports